import { classDerivedDeviceEnabledTypes } from '@iotv/datamodel';
import { DeviceTypes, UNCLASSIFIED_DOMAIN } from '@iotv/iotv-v3-types';
import { generateDomainTreeMap } from './generateDomainTreeMap';
/**
 * This can be called from the venture-specific UI folder to easily generate a domain tree mapping from a simple data structure
 *
 * It is the venture's responsibility to export the result for consumption by the UI
 *
 * This is also used internally by the UI to generate a domain tree mapping from the config
 */
export const generateDomainTreeMapping = (domainMap) => {
    const domains = Object.keys(domainMap);
    /** if there are no domains configured, early return */
    if (domains.length === 0)
        return null;
    const hasAllEntities = domains.every((domain) => domainMap[domain].objectTypeIds !== undefined);
    const hasAllDevices = domains.every((domain) => domainMap[domain].deviceTypes !== undefined);
    /** if not every domain is well-defined, early return */
    if (!hasAllEntities || !hasAllDevices)
        return null;
    /** map the classified domains to a tree */
    const domainTreeMapping = domains
        .map((domain) => generateDomainTreeMap(domain, domainMap[domain].objectTypeIds, domainMap[domain].deviceTypes, domainMap[domain].defaultSortOrder))
        .flat();
    /** find the unclassified entities */
    const unclassifiedDeviceEnabledTypes = classDerivedDeviceEnabledTypes.filter((objectTypeId) => !domainTreeMapping.find(({ treeDefMap }) => treeDefMap[objectTypeId]));
    /** find the unclassified devices */
    const unclassifiedDeviceTypes = Object.values(DeviceTypes)
        .filter((deviceType) => typeof deviceType === 'number')
        .filter((deviceType) => !domainTreeMapping.find(({ treeDefMap }) => treeDefMap[DeviceTypes[deviceType]]));
    /** map the unclassified domains to a tree */
    const unclassifiedTreeMapping = generateDomainTreeMap(UNCLASSIFIED_DOMAIN, unclassifiedDeviceEnabledTypes, unclassifiedDeviceTypes);
    domainTreeMapping.push(...unclassifiedTreeMapping);
    return domainTreeMapping;
};
